import { getFullname, defineCustomElement } from '@bdc-libs/trinity.lit-helpers';
import { createComponent } from '@lit-labs/react';
import { useEffect } from 'react';

/**
 * Creates an adapt function that adapts a Trinity web component as a React component.
 */ const createTrinityReactAdaptor = (namespace, // eslint-disable-next-line @typescript-eslint/no-explicit-any
react)=>{
    // defineDynamicTagNamespace(namespace);
    // eslint-disable-next-line @typescript-eslint/ban-types
    return (elementClass, displayName)=>{
        var _elementClass_tagName;
        const fullname = getFullname(namespace, (_elementClass_tagName = elementClass.tagName) !== null && _elementClass_tagName !== void 0 ? _elementClass_tagName : elementClass.name);
        if (elementClass.setNamespace && namespace) {
            elementClass.setNamespace(namespace);
        }
        defineCustomElement(fullname, elementClass);
        // Create React component for the Trinity web component
        return createComponent({
            tagName: fullname,
            elementClass,
            events: elementClass.eventBindings,
            displayName,
            react
        });
    };
};

/**
 * Add an event listener to an HTML element.
 * Automatically remove the listener when the HTML elemnt is unmounted.
 *
 * @param ref - A React Ref object of an HTML Element
 * @param eventType - Event type, e.g. 'change'
 * @param eventListener - Event listener function
 * @param [isElementReady=true] - Optional. Boolean flag indicating if the element is ready in DOM. Default to true.
 */ const useEvent = (ref, eventType, eventListener, isElementReady = true)=>{
    useEffect(()=>{
        if (isElementReady) {
            var _el_addEventListener;
            const el = ref.current;
            el === null || el === void 0 ? void 0 : (_el_addEventListener = el.addEventListener) === null || _el_addEventListener === void 0 ? void 0 : _el_addEventListener.call(el, eventType, eventListener);
            return ()=>{
                var _el_removeEventListener;
                el === null || el === void 0 ? void 0 : (_el_removeEventListener = el.removeEventListener) === null || _el_removeEventListener === void 0 ? void 0 : _el_removeEventListener.call(el, eventType, eventListener);
            };
        }
        return ()=>{};
    }, [
        ref,
        eventType,
        eventListener,
        isElementReady
    ]);
};

export { createTrinityReactAdaptor, useEvent };
